module.exports = __webpack_public_path__ + "static/media/mode-white.f7e49ec7.svg";